import {put, takeLatest, call} from 'redux-saga/effects';
import * as paymentService from "../../../services/paymentService";
import {
    PURCHASE,
    PURCHASE_SUCCESS,
    PURCHASE_ERROR,
}
    from "../../actions/payment"

function* purchaseSaga(action) {
    try {
       const data  = yield call(paymentService.Purchase,action.payload)
       yield put({
        type: PURCHASE_SUCCESS,
        payload: data
    })


    } catch (error) {
        yield put({
            type: PURCHASE_ERROR,error: error.data
        })
    }
}


export function* purchaseSagaWatcher() {
    yield takeLatest(PURCHASE, purchaseSaga)
}